export default __webpack_public_path__ + "static/media/methodist-3.5e3673e7.jpg";